import { capitalize } from 'lodash';
import { GetLfaConversionFilterType } from '~/graphql/types';

type ReturnType = {
  queryStr: string | null;
  tab: GetLfaConversionFilterType | undefined;
};

// Helper function to parse URL parameters (only reads, doesn't write)
const parseUrlParams = (params: URLSearchParams): ReturnType => {
  const query = params.get('query');
  const _tab = params.get('tab');

  const tab = capitalize(_tab ?? undefined);

  // Validate and convert tab to proper enum value
  const validTab =
    tab &&
    Object.values(GetLfaConversionFilterType).includes(
      tab as GetLfaConversionFilterType,
    )
      ? (tab as GetLfaConversionFilterType)
      : undefined;

  return {
    queryStr: query,
    tab: validTab,
  };
};

export default parseUrlParams;
